// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"54":"42715d79","96":"2efcca27","331":"8a2a4456","590":"3f7d6e9c","595":"0344bbcd","607":"6c6a9425","985":"b6b36a51"}[chunkId] + ".chunk.js";
};